<template>
  <div class="decorate">
    <div class="decorate-top">
      <div class="decorate-app" v-if="info">
        <div class="decorate-app-name">{{ info.name }}</div>
      </div>
      <h3 class="decorate-top-title">
        {{ type == "act" ? "活动首页装修" : "模板设置" }}
      </h3>
      <a-space class="decorate-btn">
        <template v-if="isActivity">
          <div class="btn-item">
            <a-button type="primary" @click="saveToTemp">
              存为模板
            </a-button>
            <a-divider type="vertical" />
          </div>
        </template>
        <a-button @click="cancel">取消</a-button>
        <a-divider type="vertical" />
        <a-button type="primary" @click="save">保存</a-button>
      </a-space>
    </div>
    <div class="decorate-detail">
      <div class="controls">
        <ul class="temp-list">
          <li
            class="control-item"
            draggable
            @dragstart="handleDragStart($event, i)"
            v-for="(c, i) in controls"
            :key="i"
          >
            {{ c.title }}
          </li>
        </ul>
      </div>
      <div class="preview">
        <div class="preview-area">
          <div class="temp-name" v-if="!isActivity">
            <div class="name-title">模板名称：</div>
            <a-input placeholder="模板名称" v-model="name"></a-input>
          </div>
          <control-list
            class="pre-box"
            @change="handleListChange"
            :style="pageStyle"
            :controls="list"
          ></control-list>
        </div>
      </div>
      <div class="setting">
        <template v-if="select">
          <h3 class="setting-title">{{ select.title }}</h3>
          <div class="setting-form">
            <carousel-edit
              ref="controlEdit"
              :value="config"
              @change="handleConfigChange"
              v-if="select.type == 'carousel'"
            ></carousel-edit>
            <article-edit
              ref="controlEdit"
              :value="config"
              @change="handleConfigChange"
              v-else-if="select.type == 'article'"
            ></article-edit>
            <file-edit
              ref="controlEdit"
              :value="config"
              @change="handleConfigChange"
              v-else-if="select.type == 'file'"
            ></file-edit>
            <banner-edit
              ref="controlEdit"
              :value="config"
              @change="handleConfigChange"
              v-else-if="select.type == 'banner'"
            ></banner-edit>
            <guest-edit
              ref="controlEdit"
              :value="config"
              @change="handleConfigChange"
              v-else-if="select.type == 'guest'"
            ></guest-edit>
            <live-edit
              ref="controlEdit"
              :value="config"
              @change="handleConfigChange"
              v-else-if="select.type == 'live'"
            ></live-edit>
            <tabs-edit
              ref="controlEdit"
              :value="config"
              @change="handleConfigChange"
              v-else-if="select.type == 'tabs'"
            ></tabs-edit>
            <icons-edit
              ref="controlEdit"
              :value="config"
              @change="handleConfigChange"
              v-else-if="select.type == 'icons'"
            ></icons-edit>
          </div>
          <div class="setting-btn">
            <a-button type="primary" @click="saveControl">
              保存
            </a-button>
          </div>
        </template>
        <template v-else>
          <h3 class="setting-title">页面配置</h3>
          <div class="setting-form">
            <a-form-model
              :model="page"
              class="form"
              :layout="pageLayout"
              :label-col="pageLabelCol"
              :wrapper-col="pageWrapperCol"
            >
              <a-form-model-item label="页面背景图片">
                <cl-upload direct v-model="page.backgroundImage"></cl-upload>
              </a-form-model-item>
              <a-form-model-item label="页面背景色">
                <colorPicker
                  class="color-picker shadow"
                  v-model="page.backgroundColor"
                ></colorPicker>
              </a-form-model-item>
              <a-form-model-item label="页面内边距" v-if="page.padding">
                <a-space>
                  <a-input
                    type="number"
                    class="inline-input"
                    placeholder="上"
                    v-model="page.padding.top"
                  ></a-input>
                  <a-input
                    type="number"
                    class="inline-input"
                    placeholder="下"
                    v-model="page.padding.bottom"
                  ></a-input>
                  <a-input
                    type="number"
                    class="inline-input"
                    placeholder="左"
                    v-model="page.padding.left"
                  ></a-input>
                  <a-input
                    type="number"
                    class="inline-input"
                    placeholder="右"
                    v-model="page.padding.right"
                  ></a-input>
                </a-space>
              </a-form-model-item>
            </a-form-model>
          </div>
          <div class="setting-btn">
            <a-button type="primary" @click="savePageConfig">
              保存
            </a-button>
          </div>
        </template>
      </div>
    </div>
    <modal
      hold
      title="请输入模板名称"
      width="300px"
      @confirm="confirmTempName"
      :show.sync="dv"
    >
      <a-input v-model="name" placeholder="请输入模板名称"></a-input>
    </modal>
  </div>
</template>

<script>
import controls from "../common/js/controls";
import carouselEdit from "../components/control/carousel-edit";
import articleEdit from "../components/control/article-edit";
import fileEdit from "../components/control/file-edit";
import bannerEdit from "../components/control/banner-edit";
import liveEdit from "../components/control/live-edit";
import guestEdit from "../components/control/guest-edit";
import tabsEdit from "../components/control/tabs-edit";
import iconsEdit from "../components/control/icons-edit";
import { clone, getDistance } from "../common/js/tool";
import controlList from "../components/control/control-list";
import clUpload from "../components/cl-upload";
import modal from "../components/modal";

export default {
  name: "Decorate",
  components: {
    carouselEdit,
    articleEdit,
    fileEdit,
    bannerEdit,
    guestEdit,
    liveEdit,
    tabsEdit,
    iconsEdit,
    controlList,
    clUpload,
    modal,
  },
  data() {
    return {
      info: {},

      controls,
      config: {}, //单个组件配置信息
      list: [],
      select: null,
      name: null, //模板名称
      page: {
        backgroundColor: "transparent",
        padding: {
          top: null,
          left: null,
          right: null,
          bottom: null,
        },
      },
      pageLabelCol: {},
      pageWrapperCol: {},
      pageLayout: "vertical",
      dv: false,
      edit: false,
    };
  },
  provide() {
    return {
      setSelect: this.setSelect,
      build: this,
    };
  },
  computed: {
    /* 模板或者活动的id */
    id() {
      return this.$route.params.id;
    },
    /* 装修类型 temp 模板设置 act 活动首页装修 */
    type() {
      return this.$route.query.type;
    },
    /* 是否是新增模板的设置 */
    isAdd() {
      return this.id == "add";
    },
    pageStyle() {
      let page = this.page;
      let style = {};
      if (page.backgroundImage) {
        style.backgroundImage = `url(${page.backgroundImage})`;
      }
      if (page.backgroundColor) {
        style.backgroundColor = page.backgroundColor;
      }
      if (page.padding) {
        style.padding = getDistance(page.padding);
      }
      return style;
    },
    isActivity() {
      return this.type == "act";
    },
  },
  watch: {
    "$route.path": () => {
      this.getDetail();
    },
    select(val) {
      if (val) {
        this.config = clone(val.config);
        this.$store.commit("selectControl", val.key);
      } else {
        this.config = {};
        this.$store.commit("selectControl", null);
      }
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      if (!this.id) {
        return;
      }
      let url = `/activity/activity${this.isActivity ? "" : "-temp"}/${
        this.id
      }`;
      this.$axios({
        url,
        method: "GET",
      }).then((data) => {
        this.setConf(data);
      });
    },
    //设置初始配置
    setConf(item) {
      let conf = { id: item.id };
      if (item.config || item.temp_config) {
        try {
          let temp = {};
          if (this.isActivity) {
            // 活动解析
            temp = JSON.parse(item.config);
          } else {
            // 模板解析
            temp = JSON.parse(item.temp_config);
          }
          conf = Object.assign(conf, temp);
        } catch (e) {
          console.error(e);
          this.$message.warning("首页配置解析失败");
        }
      }
      if (conf) {
        if (Object.prototype.toString.call(conf.list) === "[object Array]") {
          this.list = clone(conf.list);
        }
        //活动页面配置
        if (conf.page) {
          let page = clone(conf.page);
          if (!page.padding) {
            page.padding = {
              top: null,
              left: null,
              right: null,
              bottom: null,
            };
          }
          this.page = page;
        }
        if (item.name) {
          this.$set(this.info, "name", item.name);
          if (!this.isActivity) {
            //模板名称
            this.name = item.name;
          }
        }
      } else {
        this.config = {};
        this.list = [];
        this.select = null;
        this.nav = null;
        this.name = null;
        this.page = {
          padding: {
            top: null,
            left: null,
            right: null,
            bottom: null,
          },
        };
        this.edit = false;
      }
    },
    setSelect(select) {
      //已选择取消选择
      if (this.select && this.select.key == select.key) {
        this.select = null;
      } else {
        this.select = select;
      }
    },
    handleListChange(list) {
      this.list = list;
    },
    handleConfigChange(config) {
      this.$set(this.select, "config", config);
      this.$set(this.select, "checked", null);
      this.edit = true;
    },
    savePageConfig() {
      this.$message.success("保存成功");
    },
    handleDragStart(e, i) {
      e.dataTransfer.setData("text/plain", i);
    },
    saveControl() {
      let msg = this.$refs.controlEdit.validate();
      if (msg) {
        this.$set(this.select, "checked", false);
        this.$message.warning(msg);
      } else {
        this.$message.success("保存成功");
        this.$set(this.select, "checked", true);
      }
    },
    cancel() {
      if (this.edit) {
        this.$confirm({
          title: "提示",
          content: "离开此页您的修改不会保存？，确认离开吗？",
          onOk: () => {
            this.tempClose();
          },
          onCancel: () => {},
        });
      } else {
        this.tempClose();
      }
    },
    save() {
      // 模板配置 校验模板名称
      if (!this.isActivity && !this.name) {
        this.$message.warning("请输入模板名称");
        return;
      }
      if (this.checkConf()) {
        if (this.isActivity) {
          this.saveActivity();
        } else {
          this.saveTemp();
        }
      }
    },
    saveToTemp() {
      if (this.checkConf()) {
        this.dv = true;
      }
    },
    backInfo() {
      if (this.isActivity) {
        this.$router.push({ name: "ActivityInfo", params: { id: this.id } });
      } else {
        this.$router.push({ name: "Template" });
      }
    },
    checkConf() {
      let list = this.list;
      let flag = true;
      for (let i = 0, l = list.length; i < l; i++) {
        let c = list[i];
        if (c.checked === null) {
          flag = false;
          this.select = c;
          this.$message.warning(`第${i + 1}个组件尚未保存，请先保存`);
          break;
        } else if (c.checked === false) {
          flag = false;
          this.select = c;
          this.$message.warning(`第${i + 1}个组件配置有误，请检查配置`);
          break;
        }
      }
      return flag;
    },
    saveActivity() {
      let id = this.id,
        list = this.list,
        page = this.page;
      let url = "/activity/activity/" + id;
      this.$axios({
        url,
        method: "PATCH",
        data: {
          config: JSON.stringify({ page, list }),
        },
      }).then(() => {
        this.$message.success("保存成功");
        this.tempClose(true);
      });
    },
    confirmTempName() {
      this.saveTemp();
      this.dv = false;
    },
    saveTemp() {
      let id = !this.isActivity ? this.id : null, //仅当为模板装修时 才通过id判断是新增还是更新
        name = this.name,
        list = this.list,
        page = this.page;
      let url = id
        ? `/activity/activity-temp/${id}`
        : "/activity/activity-temp";
      this.$axios({
        url,
        method: id ? "PATCH" : "POST",
        data: {
          name,
          temp_config: JSON.stringify({ page, list }),
        },
      }).then(() => {
        this.$message.success("保存成功");
        this.tempClose(true);
      });
    },
    // 关闭模板页
    tempClose(update) {
      if (!this.id) {
        this.$emit("close", update);
      } else {
        this.backInfo();
      }
    },
  },
};
</script>

<style scoped lang="less">
.decorate {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.decorate-top {
  position: relative;
  padding: 24px 0;
  box-shadow: 0 1px 0 0 #dbdbdb;
}
.decorate-app {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 36px;
  bottom: 0;
  margin: auto 0;
}
.decorate-app-icon {
  width: 48px;
  height: 48px;
  border-radius: 4px;
}
.decorate-app-name {
  margin-left: 12px;
  font-size: 16px;
}
.decorate-btn {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 36px;
  margin: auto 0;
}
.decorate-top-title {
  margin: 0;
  text-align: center;
  font-size: 18px;
}
.decorate-detail {
  flex: 1;
  display: flex;
  padding: 24px;
  background-color: @background-color-light;
  min-height: 0;
  min-width: 0;
  overflow: scroll;
}

.setting,
.controls {
  width: 300px;
  background-color: #ffffff;
  box-shadow: @box-shadow-base;
}
.controls {
  overflow: auto;
}
.temp-list {
  padding: 0 20px 20px;
}
.control-item {
  margin-top: 10px;
  padding: 15px 0;
  background-color: #eee;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
}

.preview {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10px;
}
.preview-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 377px;
  height: 100%;
  background: url(../assets/bg.png) center / cover no-repeat, linear-gradient(180deg, #0b79ff 0%, #8ae7da 100%);
}
.temp-name {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 377px;
}
.name-title {
  width: 100px;
}
.pre-box {
  flex: 1;
  background: center no-repeat;
  background-size: cover;
  overflow: auto;
  border: var(--border);
  box-shadow: @box-shadow-base;
}

.setting {
  display: flex;
  flex-direction: column;
}
.setting-title {
  flex-shrink: 0;
  padding: 10px;
  border-bottom: var(--border);
  text-align: center;
}
.setting-btn {
  flex-shrink: 0;
  padding: 10px;
  border-top: var(--border);
  text-align: center;
}
.setting-form {
  flex: 1;
  padding: 10px;
  overflow: auto;
}
.color-picker::v-deep {
  .colorBtn {
    width: 20px;
    height: 20px;
  }
}
</style>
